module.exports = __webpack_public_path__ + "exo-latin-200.459a2b5c4d21445ecaa1.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-200.eot
// module id = ../../../../typeface-exo/files/exo-latin-200.eot
// module chunks = styles